<template>
  <div
    class="flex flex-col flex-1 bg-white rounded-xl m-5 p-4 h-full overflow-hidden"
  >
    <div class="flex justify-start items-center mb-4 flex-shrink-0">
      <reports-filters @submitReport="getStatusResult"></reports-filters>
    </div>

    <div class="flex-1 overflow-hidden flex flex-col">
      <div class="flex-1 overflow-auto">
        <DataTable :value="userStatuses">
      <template #empty>
        <p class="text-primary-900 text-sm text-center">
          {{ $t("reports.agent_status_report.no_statuses") }}
        </p>
      </template>
      <Column
        header-class="bg-primary-900 text-white set-border text-center font-weight-medium rounded-s-lg text-xs !px-0"
        body-class="text-sm text-center !px-0"
        field="time"
        :header="$t('reports.agent_status_report.head_time')"
      >
        <template #body="slotProps">
          {{ getTime(slotProps.data.time) }}
        </template></Column
      >
      <Column
        header-class="bg-primary-900 text-white set-border text-center font-weight-medium text-xs !px-0"
        body-class="text-sm text-center !px-0"
        field="time"
        :header="$t('reports.agent_status_report.head_date')"
      >
        <template #body="slotProps">
          {{ getDate(slotProps.data.time) }}
        </template></Column
      >
      <Column
        header-class="bg-primary-900 text-white set-border text-center font-weight-medium text-xs !px-0"
        body-class="text-sm text-center !px-0"
        field="status "
        :header="$t('reports.agent_status_report.head_action')"
      >
        <template #body="slotProps">
          <span
            :class="`${
              setStatus(slotProps.data.status).class
            } w-fit py-1 px-2 rounded-md `"
          >
            <Badge :class="setStatus(slotProps.data.status).badgeClass" />
            {{ setStatus(slotProps.data.status).status }}
          </span>
        </template></Column
      >
      <Column
        header-class="bg-primary-900 text-white set-border text-center font-weight-medium rounded-e-lg text-xs !px-0"
        body-class="text-sm text-center !px-0"
        field="duration"
        :header="$t('reports.agent_status_report.head_duration')"
      ></Column>
        </DataTable>
      </div>
    
      <!-- Pagination -->
      <div v-if="paginationLength > 1" class="flex-shrink-0 bg-white border-t border-gray-200 shadow-sm mt-4">
        <div class="px-3 py-2">
          <report-pagination
            :current-page="page"
            :total-pages="paginationLength"
            :total-count="count"
            :records-per-page="limit"
            :available-limits="[10, 25, 50, 100]"
            :show-records-per-page="true"
            :show-pagination-info="true"
            :show-jump-to-page="false"
            @page-change="goToPage"
            @records-per-page-change="handleRecordsPerPageChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportsFilters from "@/components/ReportsFilters.vue";
import ReportPagination from "@/pages/reports/components/ReportPagination.vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { getTime, getDate } from "@/utils";
import { mapActions } from "vuex";
import { Badge } from "primevue";
import moment from "moment";

export default {
  name: "agent-status-report",
  data() {
    return {
      count: 0,
      showProgress: false,
      limit: 10,
      filters: null,
      page: 1,
      lastIndex: 1,
      firstIndex: 1,
      showCount: false,
      paginationLength: 1,
      userStatuses: [],
      isSubmit: false,
    };
  },
  components: {
    ReportsFilters,
    ReportPagination,
    DataTable,
    Column,
    Badge,
  },
  methods: {
    ...mapActions([
      "GetAgentStatusReport",
      "ShowProgressBar",
      "SetMessageDialog",
    ]),
    async getStatusResult(sentFilters) {
      let payload = {
        from: sentFilters.from,
        to: sentFilters.to,
        offset: this.page - 1,
        limit: this.limit,
        export: sentFilters.export,
      };
      this.filters = payload;
      this.page = 1;
      await this.getPageData(true);
    },
    async getPageData(newReq) {
      this.showProgress = true;
      this.isSubmit = newReq;
      var getcount = newReq ? 1 : 0;
      this.filters.iscount = getcount;
      this.filters.offset = (this.page - 1) * this.limit;
      try {
        var resp = await this.GetAgentStatusReport(this.filters);
        this.showProgress = false;
        this.isSubmit = false;
        if (!this.filters.export || resp)
          if (!resp.success) {
            this.SetMessageDialog({ show: true, message: resp.message });
          } else {
            this.userStatuses = resp.records;
            if (newReq) {
              this.count = resp.count;
              this.showCount = true;
              this.setPaginations();
            }
            // this.showProgress = false;
          }
      } catch (err) {
        let message = err.message;
        if (err.response) {
          message = err.response.data.message;
        }
        this.showProgress = false;
        this.SetMessageDialog({ show: true, message: message });
      }
    },
    setPaginations() {
      var pageCount = Math.floor(this.count / this.limit);
      pageCount = pageCount > 1 ? pageCount : 1;
      if (
        pageCount >= 1 &&
        this.count > this.limit &&
        this.count % this.limit > 0
      ) {
        pageCount++;
      }

      this.paginationLength = pageCount;
    },
    setStatus(status) {
      if (status == 1) {
        return {
          status: this.$t("reports.agent_status_report.status_online"),
          class: "bg-primary-50 text-primary-500",
          badgeClass: "bg-primary-500",
        };
      } else if (status == 2) {
        return {
          status: this.$t("reports.agent_status_report.status_rest"),
          class: "bg-orange-50 text-orange-900",
          badgeClass: "bg-orange-900",
        };
      } else if (status == 3) {
        return {
          status: this.$t("reports.agent_status_report.status_busy"),
          class: "bg-yellow-50 text-yellow-900",
          badgeClass: "bg-yellow-900",
        };
      } else {
        return {
          status: this.$t("reports.agent_status_report.status_offline"),
          class: "bg-red-50 text-red-900",
          badgeClass: "bg-red-900",
        };
      }
    },
    getTime(date) {
      return getTime(date);
    },
    getDate(date) {
      return getDate(date);
    },
    goToPage(pageNumber) {
      if (pageNumber >= 1 && pageNumber <= this.paginationLength) {
        this.page = pageNumber;
      }
    },
    handleRecordsPerPageChange(newLimit) {
      this.limit = newLimit;
      this.page = 1;
      this.getPageData(true);
    },
  },
  computed: {
    currentLocal() {
      return this.$vuetify.locale.current;
    },
  },
  watch: {
    async page() {
      if (!this.isSubmit) {
        this.filters.export = false;
        await this.getPageData();
      }
    },
  },
  mounted() {
    this.getStatusResult({
      from: moment().format("YYYY-MM-DD") + " 00:00:00",
      to: moment().format("YYYY-MM-DD") + " 23:59:59",
    });
  },
};
</script>
<style scoped>
.p-datatable-tbody > tr:nth-child(even) {
  background-color: transparent;
}

.p-datatable-tbody > tr:nth-child(odd) {
  background-color: #ffffff;
}

/* Center header text in PrimeVue DataTable */
:deep(.p-datatable-thead th.text-center .p-datatable-column-header-content) {
  justify-content: center !important;
}
</style>
